import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import "../css/clients.css";
import AdminMenu from './adminMenu';
const ClientsTable = ({ setIsAuthenticated }) => {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editingClient, setEditingClient] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchClients = async () => {
        try {
            const response = await axios.get('/api/clients');
            const normalized = (response.data || []).map(c => ({
                clientId: c.clientId ?? c.ClientId,
                name: c.name ?? c.Name,
                company: c.company ?? c.Company,
                email: c.email ?? c.Email,
                phone: c.phone ?? c.Phone,
                notes: c.notes ?? c.Notes,
                createdAt: c.createdAt ?? c.CreatedAt
            }));
            setClients(normalized);
        } catch (err) {
            setError(err.message || 'Error fetching clients');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        fetchClients();
    }, []);

    const handleChange = (field, value) => {
        setEditingClient(prev => ({ ...prev, [field]: value }));
    };

    const handleSave = async () => {
        const toNull = (v) =>
            v === undefined || v === null || v.trim() === ""
                ? null
                : v.trim();

        try {
            const client = editingClient;
            const isNew = !client.clientId || client.clientId < 0;

            let payload;

            if (isNew) {
                // CREATE
                payload = {
                    Name: client.name.trim(),
                    Company: toNull(client.company),
                    Email: toNull(client.email),
                    Phone: toNull(client.phone),
                    Notes: toNull(client.notes)
                };

                await axios.post('/api/clients', payload);
            } else {
                // UPDATE
                payload = {
                    ClientId: client.clientId,
                    Name: client.name.trim(),
                    Company: toNull(client.company),
                    Email: toNull(client.email),
                    Phone: toNull(client.phone),
                    Notes: toNull(client.notes)
                };

                await axios.post(`/api/clients/${client.clientId}`, payload);
            }

            await fetchClients();

            setEditingClient(null);

            alert("Client saved!");
        } catch (err) {
            console.error("SAVE ERROR:", err.response?.data || err);

            alert(
                "Error saving client: " +
                (err.response?.data?.title || err.message)
            );
        }
    };


    const handleEdit = (client) => {
        setEditingClient(client);
    };

    const handleAddNew = () => {
        const tempId = Date.now() * -1;
        const newClient = {
            clientId: tempId,
            name: "",
            company: "",
            email: "",
            phone: "",
            notes: ""
        };
        setClients(prev => [newClient, ...prev]);
        setEditingClient(newClient);
    };

    /** 🔍 FILTERED CLIENTS */
    const filteredClients = useMemo(() => {
        const term = searchTerm.toLowerCase().trim();

        if (!term) return clients;

        return clients.filter(c =>
            (c.name || "").toLowerCase().includes(term) ||
            (c.company || "").toLowerCase().includes(term)
        );
    }, [clients, searchTerm]);

    if (loading) return <p className="loading">Loading clients...</p>;
    if (error) return <p className="error">{error}</p>;

    return (
        <div className="admin-container">
            <AdminMenu setIsAuthenticated={setIsAuthenticated} />
        <div className="table-container">

            <div className="button-wrapper">
                <button className="add-button" onClick={handleAddNew}>
                    + Add New Client
                </button>

                {/*  SEARCH BOX */}

                <input
                    type="text"
                    className="search-input"
                    placeholder="Search by name or company..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <table className="clients-table">
                <thead>
                    <tr>
                        {["Name", "Company", "Email", "Phone", "Notes", "Actions"].map(col => (
                            <th key={col}>{col}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {filteredClients.length === 0 ? (
                        <tr>
                            <td colSpan="6" style={{ textAlign: "center" }}>
                                No clients found
                            </td>
                        </tr>
                    ) : (
                        filteredClients.map(client => (
                            <tr key={client.clientId}>
                                <td>{client.name}</td>
                                <td>{client.company}</td>
                                <td>{client.email}</td>
                                <td>{client.phone}</td>
                                <td>{client.notes}</td>
                                <td>
                                    <button
                                        className="edit-button"
                                        onClick={() => handleEdit(client)}
                                    >
                                        Edit
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {/* MODAL */}
            {editingClient && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h2>{editingClient.clientId < 0 ? "Add New Client" : "Edit Client"}</h2>

                        {[
                            { name: "name", type: "text" },
                            { name: "company", type: "text" },
                            { name: "email", type: "email" },
                            { name: "phone", type: "tel" },
                            { name: "notes", type: "textarea" }
                        ].map(field => (
                            <div key={field.name} className="modal-field">
                                <label>
                                    {field.name.charAt(0).toUpperCase() + field.name.slice(1)}:
                                </label>
                                {field.type === "textarea" ? (
                                    <textarea
                                        value={editingClient[field.name] || ""}
                                        onChange={(e) => handleChange(field.name, e.target.value)}
                                    />
                                ) : (
                                    <input
                                        type={field.type}
                                        value={editingClient[field.name] || ""}
                                        onChange={(e) => handleChange(field.name, e.target.value)}
                                    />
                                )}
                            </div>
                        ))}

                        <div className="modal-actions">
                            <button onClick={handleSave} className="save-button">Save</button>
                            <button onClick={() => setEditingClient(null)} className="cancel-button">Cancel</button>
                        </div>
                    </div>
                </div>
            )}
            </div>
        </div>
    );
};

export default ClientsTable;
